var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.586608 6.30273C0.447092 6.30273 0.333984 6.41583 0.333984 6.55536V10.2689C0.333984 12.6209 1.84467 14.2014 4.09303 14.2014H12.5736C14.8228 14.2014 16.3335 12.6209 16.3335 10.2689V6.55536C16.3335 6.41583 16.2204 6.30273 16.0809 6.30273H0.586608Z",
    opacity: 0.4,
    fill: "#1080FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0809 5.03998C16.2204 5.03998 16.3335 4.92688 16.3335 4.78735V4.72841C16.3335 2.37648 14.8228 0.795898 12.5736 0.795898H4.09303C1.84467 0.795898 0.333984 2.37648 0.333984 4.72841V4.78735C0.333984 4.92688 0.447084 5.03998 0.586608 5.03998H16.0809Z",
    fill: "#1080FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27414 10.8022H6.7743C7.12293 10.8022 7.40586 10.5192 7.40586 10.1706C7.40586 9.822 7.12293 9.53906 6.7743 9.53906H4.27414C3.92552 9.53906 3.64258 9.822 3.64258 10.1706C3.64258 10.5192 3.92552 10.8022 4.27414 10.8022Z",
    fill: "#1080FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/credit_card.4facd1cb.svg";
export { ForwardRef as ReactComponent };